import { render, staticRenderFns } from "./user-registration-complete.vue?vue&type=template&id=07e9d39d&"
import script from "./user-registration-complete.vue?vue&type=script&lang=ts&"
export * from "./user-registration-complete.vue?vue&type=script&lang=ts&"
import style0 from "./user-registration-complete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports